// extracted by mini-css-extract-plugin
module.exports = {"wrap":"styles-module--wrap--3C68i","type":"styles-module--type--2lCX-","eventData":"styles-module--eventData--UrPfH","author":"styles-module--author--2iAA5"};